export default __webpack_public_path__ + "static/media/mall-banner-ms.26d7e867.jpg";